import {Pipe, PipeTransform} from "@angular/core";
import dayjs from "dayjs";

@Pipe({
	name: "minsec",
	standalone: false,
})
export class MinsecPipe implements PipeTransform {
	transform(milliseconds: number, args?: any) {
		if (milliseconds) {
			// 2017-09-18, Alex
			// milliseconds fixed. One zero too much.
			if (milliseconds >= 3601000) {
				//1h
				return dayjs().startOf("day").millisecond(milliseconds).format("HH [h] m [min] s [sec]");
			} else {
				return dayjs().startOf("day").millisecond(milliseconds).format("m [min] s [sec]");
			}
		} else {
			return "";
		}
	}
}
